import React from 'react'
import createClass from 'create-react-class'
import i18n from 'live/services/i18n'
import FormBase from 'live/components/extensions/ui/form'
import FormGroup from 'live/components/forms/ui/form-group'
import { FormCheckbox } from 'live/components/forms/ui/form-checkbox'
import TableForm from 'live/components/forms/ui/table-form'
import { Panel, PanelGroup } from 'react-bootstrap'
import Select from 'react-select'
import _ from 'lodash'
import ValidationMixin from 'live/components/forms/mixins/validation-mixin'
import ObjectInitializerMixinFactory from 'live/components/forms/mixins/object-initializer'

const ObjectInitializerMixin = ObjectInitializerMixinFactory('/rest/extension', {
    type: 'plugin-asset-setup',
    active: true,
    config: {
        witsmlURL: '',
        witsmlUsername: '',
        witsmlPassword: '',
        serviceCompany: '',
        protocolVersion: '',

        detectByIsActiveFlag: false,
        detectByOnGrowingObjects: false,
        detectByStatusWellbore: false,

        overwritePerspectives: false,
        perspectiveByOperatorDiv: false,
        perspectiveByWellField: false,
        perspectiveByRigName: false,
        defaultPerspectiveName: '',
        operatorPerspective: {},
        rigPerspective: {},

        interventionType: '',
        interventionTypePhases: {},
        dashboards: [],
        operatorDashboards: {},
        rigDashboardList: {},
        excludeAggregations: {},
        excludeAggregationsByRig: {},
        ignoreAggregations: '',
        rigDashboards: [],
        overrideExistingDashboards: false,
        disableRigNormalization: false,

        useWellName: false,
        eventTypePrefix: '',

        activeWellsSchedule: 30,
        activeWellsDelay: 0,
        pullActiveWells: false,
        maxActiveCount: 50,

        deactivateRequestsSchedule: 360,
        deactivateRequestsDelay: 5,
        deactivateRequests: false,

        completeWellsSchedule: 1440,
        completeWellsDelay: 10,
        pullCompleteWells: false,
        maxCompleteCount: 1000,

        ignoreRigs: '',
        includeRigs: '',
        interventionPush: 2880,
        ignoreLogs: '',
        includeLogs: '',
        messageMnemonic: '',
        renameRigs: {},
        renameWells: {},

        collectChangeLogs: false,
        collectLogs: false,
        collectTrajectories: false,
        collectMudLogs: false,
        collectBHARuns: false,
        collectGeometries: false,
        collectRisks: false,
        collectTubulars: false,
        calculateTrajectoryPoints: false,
        calculateImperialOnly: false,
        applyExecutionTrajectory: false,
        applyProjectTrajectory: false,
        applyInterventionTrajectory: false,

        channelsByDescription: false,
        channelSynonyms: {},
        logOrder: [],

        channelsByMnemonic: false,
        channelList: [],

        channelsByFile: false,
        channelsFileName: '',

        channelsByLiveTemplate: false,
        defaultTemplateName: '',
        forceTemplate: false,

        includeRawFields: false,
        renormalizeAutoSwitchDataGaps: false,

        updateIntervention: false,
        createIntervention: false,
        configureLiverigCollector: false,
        liverigURL: '',
        liverigUsername: '',
        liverigPassword: '',
        collectorRigList: {},
        queryPeriod: {},
        liverigDepthRevisionWaitTime: 0.0,
        liverigDepthOffset: 0.0,
        dataOnlyRequestsForLogs: false,
        remoteControl: false,

        onGrowingLogs: [],
        allowOrphanWells: false,

        trackAsyncChannelsUsingLiverigCollector: false,
        trackAsyncChannels: false,
        trackChannelLogName: '',
        trackAsyncChannelList: [],
        trackAsyncChannelQueryPeriod: 300,
        trackAsyncChannelRevisionWaitTime: 0.0,
        trackAsyncChannelDepthOffset: 0.0,

        abbreviateWellboreNames: false,
        capitalizeWells: false,
        replaceExpression: '',

        scanAllWellbores: false,

        defaultUnitSet: 'Imperial',

        corePoolSize: 10,
        maximumPoolSize: 50,

        autoStartKPI: false,
        useTimeseries: false
    },
    fullQualifier: '',
    qualifier: '',
    status: {}
})

const queryPeriodConfig = [
    {
        label: 'Log Type',
        name: 'logType',
        type: 'text'
    },
    {
        label: 'Request Periodicity',
        name: 'requestPeriodicity',
        type: 'number'
    }
]

const rigPerspectiveConfig = [
    {
        label: 'Rig Name',
        name: 'rigName',
        type: 'text'
    },
    {
        label: 'Perspective (automatically created when operator is found)',
        name: 'perspective',
        type: 'text'
    }
]

const operatorDivPerspectiveConfig = [
    {
        label: 'Operator Division (as shown in witsml)',
        name: 'operatorDivision',
        type: 'text'
    },
    {
        label: 'Perspective (automatically created when rig is found)',
        name: 'perspective',
        type: 'text'
    }
]

const collectorRigListConfig = [
    {
        label: 'Collector Host Name',
        name: 'collectorName',
        type: 'text'
    },
    {
        label: 'Rig List (comma separated)',
        name: 'rigList',
        type: 'text'
    }
]

const excludeAggregationsConfig = [
    {
        label: 'Operator Division (as shown in witsml)',
        name: 'operatorDiv',
        type: 'text'
    },
    {
        label: 'Exclude aggregations that are captured suffix regular expression',
        name: 'regEx',
        type: 'text'
    }
]

const excludeAggregationsByRigConfig = [
    {
        label: 'Rig Name (regular expression)',
        name: 'rigName',
        type: 'text'
    },
    {
        label: 'Exclude aggregations that are captured suffix regular expression',
        name: 'regEx',
        type: 'text'
    }
]

const Form = createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {}
            }
        }
    },
    onChangeCheckbox: function (e) {
        const object = this.state.object
        const config = object.config
        const field = e.target.name
        config[field] = !config[field]
        this.applyObj({
            config: config
        })
        this.handleValidation(e)
    },
    onChangeQueryPeriod(data) {
        const object = this.state.object
        const queryPeriods = {}

        _.each(data, queryPeriod => {
            let log = _.clone(queryPeriod.logType) || ''

            if (log && queryPeriods[log]) log += _.uniqueId('_')

            queryPeriods[log] = queryPeriod.requestPeriodicity
        })

        object.config.queryPeriod = queryPeriods
        this.setState(object)
    },
    onAddQueryPeriod() {
        const object = this.state.object
        const queryPeriods = object.config.queryPeriod
        const logTypes = Object.keys(queryPeriods)

        try {
            logTypes.forEach((logType, i) => {
                if (_.isEmpty(logType)) throw new Error(`${i18n(`Log Type can't be empty, fix line`)} #${i + 1}`)
            })

            this.setState({
                object: {
                    ...object,
                    config: {
                        ...object.config,
                        queryPeriod: {
                            ...object.config.queryPeriod,
                            '': ''
                        }
                    }
                }
            })
        } catch (error) {
            alert(error.message)
        }
    },
    onChangeOperatorPerspective(data) {
        const object = this.state.object
        const perspectives = {}

        _.each(data, perspectives => {
            let operatorDivision = _.clone(perspectives.operatorDivision) || ''

            if (operatorDivision && perspectives[operatorDivision]) operatorDivision += _.uniqueId('_')

            perspectives[operatorDivision] = operatorDivision.perspective
        })

        object.config.operatorPerspective = perspectives
        this.setState(object)
    },
    onAddOperatorPerspective() {
        const object = this.state.object
        const operatorPerspectives = object.config.operatorPerspective
        const operators = Object.keys(operatorPerspectives)

        try {
            operators.forEach((operator, i) => {
                if (_.isEmpty(operator)) {
                    throw new Error(`${i18n(`Operator Division can't be empty, fix line`)} #${i + 1}`)
                }
            })

            this.setState({
                object: {
                    ...object,
                    config: {
                        ...object.config,
                        operatorPerspective: {
                            ...object.config.operatorPerspective,
                            '': ''
                        }
                    }
                }
            })
        } catch (error) {
            alert(error.message)
        }
    },
    onAddRigPerspective(data) {
        const object = this.state.object
        const perspectives = {}

        _.each(data, perspectives => {
            let rigName = _.clone(perspectives.rigName) || ''

            if (rigName && perspectives[rigName]) rigName += _.uniqueId('_')

            perspectives[rigName] = rigName.perspective
        })

        object.config.rigPerspective = perspectives
        this.setState(object)
    },
    onChangeRigPerspective() {
        const object = this.state.object
        const rigPerspectives = object.config.rigPerspective
        const rigs = Object.keys(rigPerspectives)

        try {
            rigs.forEach((rig, i) => {
                if (_.isEmpty(rig)) throw new Error(`${i18n(`Rig Name can't be empty, fix line`)} #${i + 1}`)
            })

            this.setState({
                object: {
                    ...object,
                    config: {
                        ...object.config,
                        rigPerspective: {
                            ...object.config.rigPerspective,
                            '': ''
                        }
                    }
                }
            })
        } catch (error) {
            alert(error.message)
        }
    },
    onChangeCollectorRigList(data) {
        const object = this.state.object
        const collectorRigLists = {}

        _.each(data, collectorRigList => {
            let key = _.clone(collectorRigList.collectorName) || ''

            if (key && collectorRigLists[key]) key += _.uniqueId('_')

            collectorRigLists[key] = collectorRigList.rigList
        })

        object.config.collectorRigList = collectorRigLists
        this.setState(object)
    },
    onAddCollectorRigList() {
        const object = this.state.object
        const collectorRigLists = object.config.collectorRigList
        const collectorNames = Object.keys(collectorRigLists)

        try {
            collectorNames.forEach((key, i) => {
                if (_.isEmpty(key)) {
                    throw new Error(`${i18n(`Collector name can't be empty, fix line`)} #${i + 1}`)
                }
            })

            this.setState({
                object: {
                    ...object,
                    config: {
                        ...object.config,
                        collectorRigList: {
                            ...object.config.collectorRigList,
                            '': ''
                        }
                    }
                }
            })
        } catch (error) {
            alert(error.message)
        }
    },
    onChangeExcludeAggregation(data) {
        const object = this.state.object
        const excludeAggregationList = {}

        _.each(data, excludeAggregations => {
            let key = _.clone(excludeAggregations.operatorDiv) || ''

            if (key && excludeAggregationList[key]) key += _.uniqueId('_')

            excludeAggregationList[key] = excludeAggregations.regEx
        })

        object.config.excludeAggregations = excludeAggregationList
        this.setState(object)
    },
    onAddExcludeAggregation() {
        const object = this.state.object
        const excludeAggregationList = object.config.excludeAggregations
        const operatorDivs = Object.keys(excludeAggregationList)

        try {
            operatorDivs.forEach((key, i) => {
                if (_.isEmpty(key)) {
                    throw new Error(`${i18n(`Operator Division can't be empty, fix line`)} #${i + 1}`)
                }
            })

            this.setState({
                object: {
                    ...object,
                    config: {
                        ...object.config,
                        excludeAggregations: {
                            ...object.config.excludeAggregations,
                            '': ''
                        }
                    }
                }
            })
        } catch (error) {
            alert(error.message)
        }
    },
    onChangeExcludeAggregationByRig(data) {
        const object = this.state.object
        const excludeAggregationsByRigList = {}

        _.each(data, excludeAggregations => {
            let key = _.clone(excludeAggregations.rigName) || ''

            if (key && excludeAggregationsByRigList[key]) key += _.uniqueId('_')

            excludeAggregationsByRigList[key] = excludeAggregations.regEx
        })

        object.config.excludeAggregationsByRig = excludeAggregationsByRigList
        this.setState(object)
    },
    onAddExcludeAggregationByRig() {
        const object = this.state.object
        const excludeAggregationsByRigList = object.config.excludeAggregationsByRig
        const rigs = Object.keys(excludeAggregationsByRigList)

        try {
            rigs.forEach((key, i) => {
                if (_.isEmpty(key)) {
                    throw new Error(`${i18n(`Rig Name regex can't be empty, fix line`)} #${i + 1}`)
                }
            })

            this.setState({
                object: {
                    ...object,
                    config: {
                        ...object.config,
                        excludeAggregationsByRig: {
                            ...object.config.excludeAggregationsByRig,
                            '': ''
                        }
                    }
                }
            })
        } catch (error) {
            alert(error.message)
        }
    },

    render() {
        const object = this.state.object
        const config = object.config

        const witsmlProtocolOptions = [
            { value: '1.3.1.1', label: '1.3.1.1' },
            { value: '1.4.1.1', label: '1.4.1.1' }
        ]

        const queryPeriods = []

        _.each(config.queryPeriod, (queryPeriod, key) => {
            queryPeriods.push({
                logType: key,
                requestPeriodicity: queryPeriod
            })
        })

        const operatorPerspectives = []

        _.each(config.operatorPerspective, (perspective, key) => {
            operatorPerspectives.push({
                operatorDivision: key,
                perspective: perspective
            })
        })

        const rigPerspectives = []

        _.each(config.rigPerspective, (perspective, key) => {
            rigPerspectives.push({
                rigName: key,
                perspective: perspective
            })
        })

        const collectorRigLists = []

        _.each(config.collectorRigList, (rigList, key) => {
            collectorRigLists.push({
                collectorName: key,
                rigList: rigList
            })
        })

        const excludeAggregationsList = []

        _.each(config.excludeAggregations, (regEx, key) => {
            excludeAggregationsList.push({
                operatorDiv: key,
                regEx: regEx
            })
        })

        const excludeAggregationsByRigList = []

        _.each(config.excludeAggregationsByRig, (regEx, key) => {
            excludeAggregationsByRigList.push({
                rigName: key,
                regEx: regEx
            })
        })

        if (config.trackAsyncChannelList === undefined) {
            config.trackAsyncChannelList = []
        }

        return (
            <FormBase self={this}>
                <div className="form-control">
                    <PanelGroup accordion id="accordion-uncontrolled">
                        <Panel eventKey={'1'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Witsml Store Settings</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {i18n('WITSML Store URL')}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.witsmlURL"
                                    value={config.witsmlURL}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.witsmlURL')}
                                    hasFeedback
                                    help={this.errorsFor('config.witsmlURL')}
                                />
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {' '}
                                            {i18n('User Name')}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.witsmlUsername"
                                    value={config.witsmlUsername}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.witsmlUsername')}
                                    hasFeedback
                                    help={this.errorsFor('config.witsmlUsername')}
                                />
                                <FormGroup
                                    type="password"
                                    label={
                                        <span>
                                            {' '}
                                            {i18n('Password')}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.witsmlPassword"
                                    value={config.witsmlPassword}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.witsmlPassword')}
                                    hasFeedback
                                    help={this.errorsFor('config.witsmlPassword')}
                                />
                                <h4>{i18n('Protocol Version')}</h4>
                                <Select
                                    value={config.protocolVersion}
                                    options={witsmlProtocolOptions}
                                    onChange={this.onChangeProtocolVersion}
                                />
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'2'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Workflow Settings</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <FormCheckbox
                                    name="detectByIsActiveFlag"
                                    checked={
                                        typeof config.detectByIsActiveFlag !== 'undefined'
                                            ? config.detectByIsActiveFlag
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Detect active wellbores by witsml isActive flag')}
                                    disabled={undefined}
                                    note={undefined}
                                />
                                <FormCheckbox
                                    name="detectByStatusWellbore"
                                    checked={
                                        typeof config.detectByStatusWellbore !== 'undefined'
                                            ? config.detectByStatusWellbore
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Detect active wellbores using witsml Status Wellbore field')}
                                    disabled={undefined}
                                    note={undefined}
                                />
                                <FormCheckbox
                                    name="detectByOnGrowingObjects"
                                    checked={
                                        typeof config.detectByOnGrowingObjects !== 'undefined'
                                            ? config.detectByOnGrowingObjects
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n(
                                        'Detect active wellbores looking at on growing logs, mudlogs or trajectories'
                                    )}
                                    disabled={undefined}
                                    note={undefined}
                                />
                                <hr />
                                <FormCheckbox
                                    name="pullActiveWells"
                                    checked={
                                        typeof config.pullActiveWells !== 'undefined' ? config.pullActiveWells : true
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Pull Active Wells')}
                                    disabled={false}
                                    note={''}
                                />
                                {config.pullActiveWells && (
                                    <div>
                                        <FormGroup
                                            type="number"
                                            label={
                                                <span>
                                                    {i18n('Schedule in minutes')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.activeWellsSchedule"
                                            value={config.activeWellsSchedule}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.activeWellsSchedule')}
                                            hasFeedback
                                            help={this.errorsFor('config.activeWellsSchedule')}
                                        />
                                        <FormGroup
                                            type="number"
                                            label={
                                                <span>
                                                    {i18n('Max well count')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.maxActiveCount"
                                            value={config.maxActiveCount}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.maxActiveCount')}
                                            hasFeedback
                                            help={this.errorsFor('config.maxActiveCount')}
                                        />
                                        <FormGroup
                                            type="number"
                                            label={
                                                <span>
                                                    {i18n('Start Delay in Minutes')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.activeWellsDelay"
                                            value={config.activeWellsDelay}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.activeWellsDelay')}
                                            hasFeedback
                                            help={this.errorsFor('config.activeWellsDelay')}
                                        />
                                    </div>
                                )}
                                <hr />
                                <FormCheckbox
                                    name="pullCompleteWells"
                                    checked={
                                        typeof config.pullCompleteWells !== 'undefined'
                                            ? config.pullCompleteWells
                                            : true
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Pull Complete Wells')}
                                    disabled={false}
                                    note={''}
                                />
                                {config.pullCompleteWells && (
                                    <div>
                                        <FormGroup
                                            type="number"
                                            label={
                                                <span>
                                                    {i18n('Schedule in minutes')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.completeWellsSchedule"
                                            value={config.completeWellsSchedule}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.completeWellsSchedule')}
                                            hasFeedback
                                            help={this.errorsFor('config.completeWellsSchedule')}
                                        />
                                        <FormGroup
                                            type="number"
                                            label={
                                                <span>
                                                    {i18n('Max well count')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.maxCompleteCount"
                                            value={config.maxCompleteCount}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.maxCompleteCount')}
                                            hasFeedback
                                            help={this.errorsFor('config.maxCompleteCount')}
                                        />
                                        <FormGroup
                                            type="number"
                                            label={
                                                <span>
                                                    {i18n('Start Delay in Minutes')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.completeWellsDelay"
                                            value={config.completeWellsDelay}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.completeWellsDelay')}
                                            hasFeedback
                                            help={this.errorsFor('config.completeWellsDelay')}
                                        />
                                    </div>
                                )}
                                <hr />
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {i18n('Include Rigs (leave blank for all rigs)')}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.includeRigs"
                                    value={config.includeRigs}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.includeRigs')}
                                    hasFeedback
                                    help={this.errorsFor('config.includeRigs')}
                                />
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {i18n('Ignore Rigs')}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.ignoreRigs"
                                    value={config.ignoreRigs}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.ignoreRigs')}
                                    hasFeedback
                                    help={this.errorsFor('config.ignoreRigs')}
                                />
                                <hr />
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {i18n('Include Logs')}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.includeLogs"
                                    value={config.includeLogs}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.includeLogs')}
                                    hasFeedback
                                    help={this.errorsFor('config.includeLogs')}
                                />
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {i18n('Ignore Logs')}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.ignoreLogs"
                                    value={config.ignoreLogs}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.ignoreLogs')}
                                    hasFeedback
                                    help={this.errorsFor('config.ignoreLogs')}
                                />
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'3'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Liverig Collector</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <FormCheckbox
                                    name="configureLiverigCollector"
                                    checked={
                                        typeof config.configureLiverigCollector !== 'undefined'
                                            ? config.configureLiverigCollector
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Configure Liverig Collector')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="remoteControl"
                                    checked={typeof config.remoteControl !== 'undefined' ? config.remoteControl : false}
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Use Remote Control')}
                                    disabled={false}
                                    note={''}
                                />
                                {config.configureLiverigCollector && !config.remoteControl && (
                                    <div>
                                        <hr />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {i18n('Liverig URL')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.liverigURL"
                                            value={config.liverigURL}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.liverigURL')}
                                            hasFeedback
                                            help={this.errorsFor('config.liverigURL')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {i18n('User Name')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.liverigUsername"
                                            value={config.liverigUsername}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.liverigUsername')}
                                            hasFeedback
                                            help={this.errorsFor('config.liverigUsername')}
                                        />
                                        <FormGroup
                                            type="password"
                                            label={
                                                <span>
                                                    {i18n('Password')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.liverigPassword"
                                            value={config.liverigPassword}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.liverigPassword')}
                                            hasFeedback
                                            help={this.errorsFor('config.liverigPassword')}
                                        />
                                        <div>
                                            <TableForm
                                                onAdd={this.onAddCollectorRigList}
                                                visibleRows={1}
                                                fields={collectorRigListConfig}
                                                data={collectorRigLists}
                                                onChange={this.onChangeCollectorRigList}
                                            />
                                        </div>
                                        <hr />
                                        <FormCheckbox
                                            name="deactivateRequests"
                                            checked={
                                                typeof config.deactivateRequests !== 'undefined'
                                                    ? config.deactivateRequests
                                                    : true
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n('Deactivate Requests')}
                                            disabled={false}
                                            note={''}
                                        />
                                        {config.deactivateRequests && (
                                            <div>
                                                <FormGroup
                                                    type="number"
                                                    label={
                                                        <span>
                                                            {i18n('Schedule in minutes')}
                                                            <abbr title="required">*</abbr>
                                                        </span>
                                                    }
                                                    name="config.deactivateRequestsSchedule"
                                                    value={config.deactivateRequestsSchedule}
                                                    onChange={this.handleValidation}
                                                    validationState={this.validationState(
                                                        'config.deactivateRequestsSchedule'
                                                    )}
                                                    hasFeedback
                                                    help={this.errorsFor('config.deactivateRequestsSchedule')}
                                                />
                                                <FormGroup
                                                    type="number"
                                                    label={
                                                        <span>
                                                            {i18n('Start Delay (in Minutes)')}
                                                            <abbr title="required">*</abbr>
                                                        </span>
                                                    }
                                                    name="config.deactivateRequestsDelay"
                                                    value={config.deactivateRequestsDelay}
                                                    onChange={this.handleValidation}
                                                    validationState={this.validationState(
                                                        'config.deactivateRequestsDelay'
                                                    )}
                                                    hasFeedback
                                                    help={this.errorsFor('config.deactivateRequestsDelay')}
                                                />
                                            </div>
                                        )}
                                        <hr />
                                        <FormGroup
                                            type="number"
                                            label={
                                                <span>
                                                    {i18n('Revision Wait Time')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.liverigDepthRevisionWaitTime"
                                            value={config.liverigDepthRevisionWaitTime}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState(
                                                'config.liverigDepthRevisionWaitTime'
                                            )}
                                            hasFeedback
                                            help={this.errorsFor('config.liverigDepthRevisionWaitTime')}
                                        />
                                        <FormGroup
                                            type="number"
                                            label={
                                                <span>
                                                    {i18n('Depth Offset')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.liverigDepthOffset"
                                            value={config.liverigDepthOffset}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.liverigDepthOffset')}
                                            hasFeedback
                                            help={this.errorsFor('config.liverigDepthOffset')}
                                        />
                                        <hr />
                                        <FormCheckbox
                                            name="dataOnlyRequestsForLogs"
                                            checked={
                                                typeof config.dataOnlyRequestsForLogs !== 'undefined'
                                                    ? config.dataOnlyRequestsForLogs
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n('Use data-only requests for logs objects')}
                                            disabled={false}
                                            note={''}
                                        />
                                        <TableForm
                                            onAdd={this.onAddQueryPeriod}
                                            visibleRows={1}
                                            fields={queryPeriodConfig}
                                            data={queryPeriods}
                                            onChange={this.onChangeQueryPeriod}
                                        />
                                    </div>
                                )}
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'4'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Asynchronous Channel Tracking</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <FormCheckbox
                                    name="trackAsyncChannels"
                                    checked={
                                        typeof config.trackAsyncChannels !== 'undefined'
                                            ? config.trackAsyncChannels
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Individually track asynchronous channels')}
                                    disabled={false}
                                    note={''}
                                />
                                {config.trackAsyncChannels && (
                                    <div style={{ marginLeft: 20 }}>
                                        <FormGroup
                                            type="number"
                                            label={
                                                <span>
                                                    {i18n('Query periodicity in seconds')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.trackAsyncChannelQueryPeriod"
                                            value={config.trackAsyncChannelQueryPeriod}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState(
                                                'config.trackAsyncChannelQueryPeriod'
                                            )}
                                            hasFeedback
                                            help={this.errorsFor('config.trackAsyncChannelQueryPeriod')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {i18n(
                                                        'Log Name Regular Expression containing the channels to be tracked'
                                                    )}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.trackChannelLogName"
                                            value={config.trackChannelLogName}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.trackChannelLogName')}
                                            hasFeedback
                                            help={this.errorsFor('config.trackChannelLogName')}
                                        />
                                        <TableForm
                                            visibleRows={1}
                                            fields={[
                                                {
                                                    label:
                                                        'Normalized Channel to be captured (this will be translated to raw mnemonic on the fly)',
                                                    name: 'property',
                                                    type: 'text'
                                                }
                                            ]}
                                            data={
                                                config.trackAsyncChannelList !== undefined &&
                                                config.trackAsyncChannelList.map(string => ({
                                                    property: string,
                                                    value: string
                                                }))
                                            }
                                            onChange={e => {
                                                config.trackAsyncChannelList = e
                                                    .map(channel => channel.property)
                                                    .filter(channel => channel.trim())
                                            }}
                                        />
                                        <hr />
                                        {config.configureLiverigCollector && (
                                            <>
                                                <FormCheckbox
                                                    name="trackAsyncChannelsUsingLiverigCollector"
                                                    checked={
                                                        typeof config.trackAsyncChannelsUsingLiverigCollector !==
                                                        'undefined'
                                                            ? config.trackAsyncChannelsUsingLiverigCollector
                                                            : true
                                                    }
                                                    onChange={this.onChangeCheckbox}
                                                    description={i18n(
                                                        'Use liverig collector to track asynchronous channels. If this is unchecked asset-setup will track channels separately using their individual witsml indexes.'
                                                    )}
                                                    disabled={false}
                                                    note={''}
                                                />
                                                {(config.trackAsyncChannelsUsingLiverigCollector ||
                                                    config.trackAsyncChannelsUsingLiverigCollector === 'undefined') && (
                                                    <>
                                                        <FormGroup
                                                            type="number"
                                                            label={
                                                                <span>
                                                                    {i18n('Revision Wait Time')}
                                                                    <abbr title="required">*</abbr>
                                                                </span>
                                                            }
                                                            name="config.trackAsyncChannelRevisionWaitTime"
                                                            value={config.trackAsyncChannelRevisionWaitTime}
                                                            onChange={this.handleValidation}
                                                            validationState={this.validationState(
                                                                'config.trackAsyncChannelRevisionWaitTime'
                                                            )}
                                                            hasFeedback
                                                            help={this.errorsFor(
                                                                'config.trackAsyncChannelRevisionWaitTime'
                                                            )}
                                                        />
                                                        <FormGroup
                                                            type="number"
                                                            label={
                                                                <span>
                                                                    {i18n('Depth Offset')}
                                                                    <abbr title="required">*</abbr>
                                                                </span>
                                                            }
                                                            name="config.trackAsyncChannelDepthOffset"
                                                            value={config.trackAsyncChannelDepthOffset}
                                                            onChange={this.handleValidation}
                                                            validationState={this.validationState(
                                                                'config.trackAsyncChannelDepthOffset'
                                                            )}
                                                            hasFeedback
                                                            help={this.errorsFor('config.trackAsyncChannelDepthOffset')}
                                                        />
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )}
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'5'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Witsml Objects</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <FormCheckbox
                                    name="collectChangeLogs"
                                    checked={
                                        typeof config.collectChangeLogs !== 'undefined'
                                            ? config.collectChangeLogs
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Collect Change Logs')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="collectLogs"
                                    checked={typeof config.collectLogs !== 'undefined' ? config.collectLogs : false}
                                    onChange={this.collectLogs}
                                    description={i18n('Collect Log Headers')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="collectTrajectories"
                                    checked={
                                        typeof config.collectTrajectories !== 'undefined'
                                            ? config.collectTrajectories
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Collect Trajectories')}
                                    disabled={false}
                                    note={''}
                                />
                                {config.collectTrajectories && (
                                    // calculateTrajectoryPoints
                                    <div style={{ marginLeft: 20 }}>
                                        <FormCheckbox
                                            name="calculateTrajectoryPoints"
                                            checked={
                                                typeof config.calculateTrajectoryPoints !== 'undefined'
                                                    ? config.calculateTrajectoryPoints
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n(
                                                'Calculate TVD, VertSect, NS and EW for trajectory points as opposed to rely on values in the trajectory object'
                                            )}
                                            disabled={false}
                                            note={''}
                                        />
                                        <FormCheckbox
                                            name="calculateImperialOnly"
                                            checked={
                                                typeof config.calculateImperialOnly !== 'undefined'
                                                    ? config.calculateImperialOnly
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n(
                                                'If you are using calculateTrajectoryPoints, this option will only calculate if surveys come with imperial units'
                                            )}
                                            disabled={false}
                                            note={''}
                                        />
                                        <FormCheckbox
                                            name="applyProjectTrajectory"
                                            checked={
                                                typeof config.applyProjectTrajectory !== 'undefined'
                                                    ? config.applyProjectTrajectory
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n(
                                                'Apply collected trajectory to project trajectory in well parameters'
                                            )}
                                            disabled={false}
                                            note={''}
                                        />
                                        <FormCheckbox
                                            name="applyExecutionTrajectory"
                                            checked={
                                                typeof config.applyExecutionTrajectory !== 'undefined'
                                                    ? config.applyExecutionTrajectory
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n(
                                                'Apply collected trajectory to execution trajectory in well parameters'
                                            )}
                                            disabled={false}
                                            note={''}
                                        />
                                        <FormCheckbox
                                            name="applyInterventionTrajectory"
                                            checked={
                                                typeof config.applyInterventionTrajectory !== 'undefined'
                                                    ? config.applyInterventionTrajectory
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n('Apply collected trajectory to intervention')}
                                            disabled={false}
                                            note={''}
                                        />
                                    </div>
                                )}
                                <FormCheckbox
                                    name="collectMudLogs"
                                    checked={
                                        typeof config.collectMudLogs !== 'undefined' ? config.collectMudLogs : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Collect MudLogs')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="collectBHARuns"
                                    checked={
                                        typeof config.collectBHARuns !== 'undefined' ? config.collectBHARuns : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Collect BHA Runs')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="collectGeometries"
                                    checked={
                                        typeof config.collectGeometries !== 'undefined'
                                            ? config.collectGeometries
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Collect Wellbore Geometries')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="collectRisks"
                                    checked={typeof config.collectRisks !== 'undefined' ? config.collectRisks : false}
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Collect Risks')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="collectTubulars"
                                    checked={
                                        typeof config.collectTubulars !== 'undefined' ? config.collectTubulars : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Collect Tubulars')}
                                    disabled={false}
                                    note={''}
                                />
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'6'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Asset Perspectives</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {i18n(
                                                'Default perspective (leave blank to create assets without perspective)'
                                            )}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.defaultPerspectiveName"
                                    value={config.defaultPerspectiveName}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.defaultPerspectiveName')}
                                    hasFeedback
                                    help={this.errorsFor('config.defaultPerspectiveName')}
                                />
                                <FormCheckbox
                                    name="overwritePerspectives"
                                    checked={
                                        typeof config.overwritePerspectives !== 'undefined'
                                            ? config.overwritePerspectives
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n(
                                        'Overwrite perspectives. Use this option when you want to reset wellbores perspectives to their values when the wellbore was created'
                                    )}
                                    disabled={undefined}
                                    note={undefined}
                                />
                                <FormCheckbox
                                    name="perspectiveByOperatorDiv"
                                    checked={
                                        typeof config.perspectiveByOperatorDiv !== 'undefined'
                                            ? config.perspectiveByOperatorDiv
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Map WITSML field Operator Division to perspectives')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="perspectiveByRigName"
                                    checked={
                                        typeof config.perspectiveByRigName !== 'undefined'
                                            ? config.perspectiveByRigName
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Map rig names to perspectives')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="perspectiveByWellField"
                                    checked={
                                        typeof config.perspectiveByWellField !== 'undefined'
                                            ? config.perspectiveByWellField
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n(
                                        'Create perspectives using WITSML Well Field tag. If the field tag is blank it will use operator division instead'
                                    )}
                                    disabled={false}
                                    note={''}
                                />
                                {(config.perspectiveByOperatorDiv || config.perspectiveByWellField) && (
                                    <TableForm
                                        onAdd={this.onAddOperatorPerspective}
                                        visibleRows={1}
                                        fields={operatorDivPerspectiveConfig}
                                        data={operatorPerspectives}
                                        onChange={this.onChangeOperatorPerspective}
                                    />
                                )}
                                {config.perspectiveByRigName && (
                                    <TableForm
                                        onAdd={this.onAddRigPerspective}
                                        visibleRows={1}
                                        fields={rigPerspectiveConfig}
                                        data={rigPerspectives}
                                        onChange={this.onChangeRigPerspective}
                                    />
                                )}
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'7'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Intervention Settings</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {i18n('Default intervention type')}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.interventionType"
                                    value={config.interventionType}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.interventionType')}
                                    hasFeedback
                                    help={this.errorsFor('config.interventionType')}
                                />
                                <FormCheckbox
                                    name="createIntervention"
                                    checked={
                                        typeof config.createIntervention !== 'undefined'
                                            ? config.createIntervention
                                            : true
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n(
                                        'Create an intervention using available date time log indexes to define start and end'
                                    )}
                                    disabled={false}
                                    note={''}
                                />
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {i18n('Push active well intervention end X minutes from now')}
                                            <abbr title="required">*</abbr>
                                        </span>
                                    }
                                    name="config.interventionPush"
                                    value={config.interventionPush}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.interventionPush')}
                                    hasFeedback
                                    help={this.errorsFor('config.interventionPush')}
                                />
                                <FormCheckbox
                                    name="updateIntervention"
                                    checked={
                                        typeof config.updateIntervention !== 'undefined'
                                            ? config.updateIntervention
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n(
                                        'Update Interventions pushing forward the end of it to X minutes from now'
                                    )}
                                    disabled={false}
                                    note={''}
                                />
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'8'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Normalization and Asset Settings</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <FormCheckbox
                                    name="useWellName"
                                    checked={typeof config.useWellName !== 'undefined' ? config.useWellName : false}
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Use well name as opposed to wellbore name to create wells')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormGroup
                                    type="text"
                                    label={
                                        <span>
                                            {i18n('Append a prefix to wellbore event type (leave blank for none)')}
                                        </span>
                                    }
                                    name="config.eventTypePrefix"
                                    value={config.eventTypePrefix}
                                    onChange={this.handleValidation}
                                    validationState={this.validationState('config.eventTypePrefix')}
                                    hasFeedback
                                    help={this.errorsFor('config.eventTypePrefix')}
                                />
                                <FormCheckbox
                                    name="channelsByDescription"
                                    checked={
                                        typeof config.channelsByDescription !== 'undefined'
                                            ? config.channelsByDescription
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n(
                                        'Match WITSML Mnemonic Description with Standard Channels descriptions to configure normalizer'
                                    )}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="channelsByMnemonic"
                                    checked={
                                        typeof config.channelsByMnemonic !== 'undefined'
                                            ? config.channelsByMnemonic
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n(
                                        'Match WITSML Mnemonic Name with Standard Channels mnemonics to configure normalizer'
                                    )}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="channelsByLiveTemplate"
                                    checked={
                                        typeof config.channelsByLiveTemplate !== 'undefined'
                                            ? config.channelsByLiveTemplate
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n(
                                        'Assign an existing Live Template (log names must be spelled out in the pipes filter)'
                                    )}
                                    disabled={false}
                                    note={''}
                                />
                                {config.channelsByLiveTemplate && (
                                    <div style={{ marginLeft: 20 }}>
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {i18n(
                                                        'Default Template Name (if you create a template with the RIG Name, it will be applied instead)'
                                                    )}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.defaultTemplateName"
                                            value={config.defaultTemplateName}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.defaultTemplateName')}
                                            hasFeedback
                                            help={this.errorsFor('config.defaultTemplateName')}
                                        />
                                        <FormCheckbox
                                            name="forceTemplate"
                                            checked={
                                                typeof config.forceTemplate !== 'undefined'
                                                    ? config.forceTemplate
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n(
                                                'Force template to apply to the assets, regardless of manual customizations'
                                            )}
                                            disabled={undefined}
                                            note={undefined}
                                        />
                                    </div>
                                )}
                                <FormCheckbox
                                    name="channelsByFile"
                                    checked={
                                        typeof config.channelsByFile !== 'undefined' ? config.channelsByFile : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Use a file with specific rules to assign channels')}
                                    disabled={false}
                                    note={''}
                                />
                                {config.channelsByFile && (
                                    <div style={{ marginLeft: 20 }}>
                                        <FormGroup
                                            type="text"
                                            label={
                                                <span>
                                                    {i18n('File Name (uploaded on the plugins folder)')}
                                                    <abbr title="required">*</abbr>
                                                </span>
                                            }
                                            name="config.channelsFileName"
                                            value={config.channelsFileName}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.channelsFileName')}
                                            hasFeedback
                                            help={this.errorsFor('config.channelsFileName')}
                                        />
                                    </div>
                                )}
                                <FormCheckbox
                                    name="includeRawFields"
                                    checked={
                                        typeof config.includeRawFields !== 'undefined' ? config.includeRawFields : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Include raw fields while normalizing')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="renormalizeAutoSwitchDataGaps"
                                    checked={
                                        typeof config.renormalizeAutoSwitchDataGaps !== 'undefined'
                                            ? config.renormalizeAutoSwitchDataGaps
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Automatically renormalize auto-switch data gaps')}
                                    disabled={false}
                                    note={''}
                                />
                                <FormCheckbox
                                    name="disableRigNormalization"
                                    checked={
                                        typeof config.disableRigNormalization !== 'undefined'
                                            ? config.disableRigNormalization
                                            : false
                                    }
                                    onChange={this.onChangeCheckbox}
                                    description={i18n('Disable Rig Normalizer')}
                                    disabled={false}
                                    note={''}
                                />
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'9'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Dashboards</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <div>
                                    <FormCheckbox
                                        name="overrideExistingDashboards"
                                        checked={
                                            typeof config.overrideExistingDashboards !== 'undefined'
                                                ? config.overrideExistingDashboards
                                                : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n(
                                            'Override existing dashboards (if unchecked this will keep dashboards already linked and add new ones)'
                                        )}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <TableForm
                                        visibleRows={1}
                                        fields={[
                                            {
                                                label: 'Well Dashboards (these will be linked in the wells page)',
                                                name: 'property',
                                                type: 'text'
                                            }
                                        ]}
                                        data={config.dashboards?.map(string => ({
                                            property: string,
                                            value: string
                                        }))}
                                        onChange={e => {
                                            config.dashboards = e
                                                .map(dashboard => dashboard.property)
                                                .filter(dashboard => dashboard.trim())
                                        }}
                                    />
                                    <br />
                                    <TableForm
                                        visibleRows={1}
                                        fields={[
                                            {
                                                label: 'Rig Dashboards (these will be linked in the rigs page)',
                                                name: 'property',
                                                type: 'text'
                                            }
                                        ]}
                                        data={config.rigDashboards?.map(string => ({
                                            property: string,
                                            value: string
                                        }))}
                                        onChange={e => {
                                            config.rigDashboards = e
                                                .map(dashboard => dashboard.property)
                                                .filter(dashboard => dashboard.trim())
                                        }}
                                    />
                                </div>
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'10'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Aggregation Settings</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <div>
                                    <FormGroup
                                        type="text"
                                        label={
                                            <span>
                                                {' '}
                                                {i18n(
                                                    'Ignore aggregations regular expression (aggregations suffixes capture by this regex will remain untouched if the well is set to active)'
                                                )}
                                            </span>
                                        }
                                        name="config.ignoreAggregations"
                                        value={config.ignoreAggregations}
                                        onChange={this.handleValidation}
                                        validationState={this.validationState('config.ignoreAggregations')}
                                        hasFeedback
                                        help={this.errorsFor('config.ignoreAggregations')}
                                    />
                                    <hr />
                                    <h4>Exclude aggregations by Operator Division</h4>
                                    <div>
                                        <TableForm
                                            onAdd={this.onAddExcludeAggregation}
                                            visibleRows={1}
                                            fields={excludeAggregationsConfig}
                                            data={excludeAggregationsList}
                                            onChange={this.onChangeExcludeAggregation}
                                        />
                                    </div>
                                    <hr />
                                    <h4>Exclude aggregations by Rig</h4>
                                    <div>
                                        <TableForm
                                            onAdd={this.onAddExcludeAggregationByRig}
                                            visibleRows={1}
                                            fields={excludeAggregationsByRigConfig}
                                            data={excludeAggregationsByRigList}
                                            onChange={this.onChangeExcludeAggregationByRig}
                                        />
                                    </div>
                                </div>
                            </Panel.Body>
                        </Panel>
                        <Panel eventKey={'11'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Misc Settings</h3>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <div>
                                    <FormGroup
                                        type="text"
                                        label={<span> {i18n('Default Unit set')}</span>}
                                        name="config.defaultUnitSet"
                                        value={config.defaultUnitSet}
                                        onChange={this.handleValidation}
                                        validationState={this.validationState('config.defaultUnitSet')}
                                        hasFeedback
                                        help={this.errorsFor('config.defaultUnitSet')}
                                    />
                                    <FormCheckbox
                                        name="autoStartKPI"
                                        checked={
                                            typeof config.autoStartKPI !== 'undefined' ? config.autoStartKPI : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n(
                                            'Autostart realtime KPI calculations for active wells (if kpis-drilling plugin is installed)'
                                        )}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormCheckbox
                                        name="useTimeseries"
                                        checked={
                                            typeof config.useTimeseries !== 'undefined' ? config.useTimeseries : false
                                        }
                                        onChange={this.onChangeCheckbox}
                                        description={i18n(
                                            'Use timeseries collections for normalized events. You must have mongodb and mongodb-timeseries properly configured.'
                                        )}
                                        disabled={undefined}
                                        note={undefined}
                                    />
                                    <FormGroup
                                        type="number"
                                        label={<span> {i18n('Core Pool Size')}</span>}
                                        name="config.corePoolSize"
                                        value={config.corePoolSize}
                                        onChange={this.handleValidation}
                                        validationState={this.validationState('config.corePoolSize')}
                                        hasFeedback
                                        help={this.errorsFor('config.corePoolSize')}
                                    />
                                    <FormGroup
                                        type="number"
                                        label={<span> {i18n('Maximum Pool Size')}</span>}
                                        name="config.maximumPoolSize"
                                        value={config.maximumPoolSize}
                                        onChange={this.handleValidation}
                                        validationState={this.validationState('config.maximumPoolSize')}
                                        hasFeedback
                                        help={this.errorsFor('config.maximumPoolSize')}
                                    />
                                </div>
                            </Panel.Body>
                        </Panel>
                    </PanelGroup>
                </div>
            </FormBase>
        )
    }
})

export default Form
